import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GeoModule } from '@geo';


import { ClxStatusMapComponent } from './clx-status-map.component';
import { CxFormsModule } from '@forms';
import { UiTabsModule } from '@ui-tabs';
import { PlantStatusMapComponent } from './plant-status-map.component';
import { SystemStatusMapComponent } from './system-status-map.component';


@NgModule({
    imports: [
        CommonModule,
        GeoModule,
        CxFormsModule,
        UiTabsModule
    ],
    declarations: [
        ClxStatusMapComponent,
        PlantStatusMapComponent,
        SystemStatusMapComponent
    ],
    exports: [
        ClxStatusMapComponent,
        PlantStatusMapComponent,
        SystemStatusMapComponent
    ],
    providers : []
})
export class MapModule {}

export {
    ClxStatusMapComponent,
    PlantStatusMapComponent,
    SystemStatusMapComponent
};
